import { findBuildingByName, Building } from "@theguarantors/frontend-core/dist/features/buildings"
import * as yup from "yup"

export const REQUIRED = "Required"
export const INVALID_BUILDING = "Building does not exist"
export const REQUIRED_APARTMENT_NUMBER = `Unit # is required. If you don't have one, please enter "N/A"`

const apartmentNumber = yup.string().required(REQUIRED_APARTMENT_NUMBER)
const buildingAddress = (buildings: Building[] = []) => {
  return yup
    .string()
    .required(REQUIRED)
    .test("buildingAddress", INVALID_BUILDING, name => !!findBuildingByName(buildings, name))
}

export const validationSchema = {
  buildingAddress,
  apartmentNumber
}
